import {
  StyledTooltipBorder,
  StyledTooltipContainer,
  StyledTooltipContent,
  StyledTooltipTitle
} from './ChartTooltip.styles';
import { defaultStyles, TooltipWithBounds } from '@visx/tooltip';
import React, { FC, useRef } from 'react';

type TooltipProps = {
  opened: boolean;
  top: number;
  left: number;
  data: any;
  children?: React.ReactNode;
};

export interface TooltipData {
  color?: string;
  base_population_perc?: number;
  base_population_size?: number;
  description?: string;
  id?: string;
  insight_type?: string;
  label?: string;
  pic?: string;
  target_audience_affinity?: number;
  target_audience_population_perc?: number;
  target_audience_perc?: number;
  target_audience_population_size?: number;
  taxonomy?: string[];
  twitter_handle?: null | string;
  twitter_url?: null | string;
  penetration?: number;
  relevancy?: number;
  content?: any;
}

const ChartTooltip: FC<TooltipProps> = (props) => {
  const nodeRef = useRef(null);
  const tooltipStyles = {
    ...defaultStyles,
    minWidth: 60,
    backgroundColor: 'rgba(255,255,255,0.8)',
    color: '#000',
    zIndex: 2000
  };
  return (
    <TooltipWithBounds
      ref={nodeRef}
      top={props.top}
      left={props.left}
      style={{
        ...tooltipStyles,
        borderStyle: 'solid',
        borderWidth: '2px',
        borderColor: props.data.color
      }}
    >
      <StyledTooltipContainer>
        <StyledTooltipTitle>{props.data.label}</StyledTooltipTitle>
        <StyledTooltipBorder />
        <StyledTooltipContent>{props.children}</StyledTooltipContent>
      </StyledTooltipContainer>
    </TooltipWithBounds>
  );
};

export default ChartTooltip;
